// Snello global UI behaviours — loaded with `defer`, so the DOM is ready on execution.

// Sticky bar show after scroll
const stickyBar = document.getElementById('snello-sticky-bar');
if (stickyBar) {
  window.addEventListener('scroll', () => {
    stickyBar.style.display = window.scrollY > 300 ? 'flex' : 'none';
  });
}

// FAQ accordion
document.querySelectorAll('.snello-faq__question').forEach(q => {
  q.addEventListener('click', () => {
    const item = q.closest('.snello-faq__item');
    const isOpen = item.classList.contains('open');
    document.querySelectorAll('.snello-faq__item').forEach(i => i.classList.remove('open'));
    if (!isOpen) item.classList.add('open');
  });
});

// Scroll strip dots
document.querySelectorAll('.snello-scroll-strip').forEach(strip => {
  const dots = strip.nextElementSibling?.querySelectorAll('.snello-scroll-dot');
  if (!dots) return;
  strip.addEventListener('scroll', () => {
    const idx = Math.round(strip.scrollLeft / strip.offsetWidth);
    dots.forEach((d, i) => d.classList.toggle('active', i === idx));
  });
  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => {
      strip.scrollTo({ left: strip.offsetWidth * i, behavior: 'smooth' });
    });
  });
});
